// component，读取type类型文件夹下所有index.vue文件，将type类型组件导出
const components = {};
const files = require.context('./', true, /index.vue/);

files.keys().forEach(filePath => {
	// 获取文件名称，作为组件名称
	let fileName = filePath.replace('./', '').replace('/index.vue', '');
	// 读取文件内容
	let fileContent = files(filePath);
	// 若该组件是通过export default导出的，优先使用.default，否则退回到使用模块的根
	components[fileName] = fileContent.default || fileContent;
});

export default components